import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MfAccountingServicePlanComponent } from './mf-accounting-service-plan/mf-accounting-service-plan.component';

const routes: Routes = [
  {
    path: '',
    component: MfAccountingServicePlanComponent,
    children: [
      {
        path: '**',
        component: MfAccountingServicePlanComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MfAccountingServiceRoutingModule {}
